// Standard library imports
import React, { useEffect, useState } from 'react';

// Internal module imports
import Typography from '../../../components/Typography/Typography';
import Table from '../../../components/Table/Table';
import { DownloadAsExcel } from '../../../utils/downloadAsExcel';
import DownloadButton from '../../../components/Buttons/DownloadButton';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';
import { momentTimeFormater } from '../../../utils/dateHelper';


// Css module imports
import classes from '../../../styles/AllDevices.module.css';

const AllChargers = ({ devices }) => {

    const [instances, setInstances] = useState([]);

    useEffect(() => {
        if (devices?.length) {
            handleInstance();
        }
    }, [devices?.length]);


    const handleInstance = () => {
        const processedData = devices.map((instance, index) => {
            return {
                's.no': index + 1,
                name: instance.name,
                description: !instance?.description ? (
                    '--'
                ) : instance.description.length > 40 ? (
                    <CustomTooltip content={instance.description}>{instance.description.substring(0, 40) + '...'}</CustomTooltip>
                ) : (
                    instance.description
                ),
                evseId: instance?.meta?.evseId ? instance.meta.evseId : '--',
                connectors: instance?.meta?.connectors ? instance.meta.connectors : '--',
                active: instance?.meta?.isActive ? instance.meta.isActive : false,
                licenseType: 'Smart Charging',
                id: instance._id,
                createdAt: instance.createdAt ? momentTimeFormater(instance.createdAt).format('YYYY-MM-DD HH:mm:ss') : '--',
            };
        });
        setInstances(processedData);
    };

    
    const handleExport = () => {
        const processedData = [];
        devices.map((instance) => {
            processedData.push({
                name: instance.name,
                description: instance.description,
                licenseType: 'Smart Charging',
                evseId: instance?.meta?.evseId,
                connectors: instance?.meta?.connectors,
                createdAt: instance.createdAt ? momentTimeFormater(instance.createdAt).format('YYYY-MM-DD HH:mm:ss') : '',
            });
        });
        DownloadAsExcel(processedData, 'Smart_Charging_EVSEs', ['Name', 'Description', 'License Type', 'EVSE ID', 'Connectors', 'Created At (CET)']);
    };
    return (
        <div className={classes.AllDevices}>
            <div className={classes.Header}>
                <div>
                    <Typography content="All EVSEs" />
                    <div className={classes.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={devices.length} />
                        </span>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        <DownloadButton size="medium" onClick={() => handleExport()} />
                    </div>
                </div>
            </div>
            <div>
                <Table
                    head={['S.No', 'Name', 'Description', 'License Type', 'EVSE ID', 'Connectors', 'Created At (CET)',
                    ]}
                    keys={['s.no', 'name', 'description', 'licenseType', 'evseId', 'connectors', 'createdAt',
                    ]}
                    data={instances}
                />
            </div>
        </div>
    );
};

export default AllChargers;
